import PasengerSearchContainer from './PassengerSearchContainer';

export default PasengerSearchContainer;
